import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GrLinkNext } from "react-icons/gr";

import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Link,
  Modal,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
  Typography,
} from "@mui/material";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import Logo from "../image/ClearVault_logo.png";
import "../css/Register.css";
import Select from "react-select";
import { IoIosClose, IoMdInformationCircleOutline } from "react-icons/io";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";


function RegisterForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;

  const [step, setStep] = useState(1);
  const [issubmitting, setissubmitting] = useState(false);

  const steps = ["Personal Details", "Company & Bank Details"];
  const [routingNumError, setRoutingNumError] = useState("");
  const [accountNumError, setAccountNumError] = useState("");
  const [phoneNumError, setPhoneNumError] = useState("");
  
  const [invalidFiles, setInvalidFiles] = useState([]);
  
  const [previewModaTitle, setPreviewModaTitle] = useState("");
  const [previewModal, setPreviewModal] = useState(false);
  const [zipError, setZipError] = useState("");

  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [termsError, setTermsError] = useState(false);

  const firstNameRef = useRef(null);

  const [formData, setFormData] = useState({
    email: "",
    username: "",
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    city: "",
    stateName: "",
    zip: "",
    companyName: "",
    yearFounded: "",
    employees: "",
    contractorLicense: "",
    accountHolder: "",
    bankName: "",
    routingNumber: "",
    accountNumber: "",
    coOwnerName: "",
    password: "",
    // formationDoc: null,
    photoID: null,
    // EINLetter: null,
    // IRSForm: null,
    confirmPassword: "",
    // KYCBeneficial: null,
    CopyOfID: null,
    AdditionalDocuments: null,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emptyFields, setEmptyFields] = useState({});
  const [passwordError, setPasswordError] = useState("");
  const [emailErrors, setEmailErrors] = useState("");
  const [errors, setErrors] = useState({});

  const [selectedPdfFile, setSelectedPdfFile] = useState(null);

  const iframeStyleContractPdf = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };
  const yearOptions = Array.from(
    { length: new Date().getFullYear() - 1899 },
    (_, i) => new Date().getFullYear() - i
  ).map((year) => ({ value: year, label: year }));

  const maxSizes = {
    formationDoc: 20 * 1024 * 1024, // 20 MB
    photoID: 20 * 1024 * 1024, // 20 MB
    EINLetter: 10 * 1024 * 1024, // 10 MB
    IRSForm: 10 * 1024 * 1024, // 10 MB
    CopyOfID: 20 * 1024 * 1024, // 20 MB
    KYCBeneficial: 10 * 1024 * 1024, // 10 MB
    AdditionalDocuments: 10 * 1024 * 1024, // 10 MB
  };

  const allowedTypes = {
    formationDoc: ["application/pdf", "image/png", "image/jpeg"],
    photoID: ["application/pdf", "image/png", "image/jpeg"],
    EINLetter: ["application/pdf"],
    IRSForm: ["application/pdf"],
    CopyOfID: ["application/pdf", "image/png", "image/jpeg"],
    KYCBeneficial: ["application/pdf"],
    AdditionalDocuments: [
      "application/pdf",
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ],
  };

  const clearFile = (name) => {
    setFormData((prev) => ({ ...prev, [name]: null }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // ✅ Reset input field so user can re-upload same file
    const input = document.getElementById(name);
    if (input) input.value = "";
  };

  // Redirect to login if userType not found
  useEffect(() => {
    if (!state?.userType) navigate("/login", { replace: true });
    if (state?.userType) {
      firstNameRef.current.focus();
    }
  }, [state, navigate]);

  if (!state?.userType) return null;

  // Handle input change
  // ✅ Only checks password strength, NOT if it's empty
  // ✅ Password validator

  const validateDate = (date) => {
    const parsedDate = parseInt(date, 10);
    return !isNaN(parsedDate) && parsedDate >= 1 && parsedDate <= 30;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (name === "email" && value.trim() !== "") {
      if (!validateEmail(value)) {
        setEmailErrors("Invalid email address");
        setEmptyFields((prev) => ({
          ...prev,
          email: true,
        }));
      } else {
        setEmailErrors("");
      }
    }
  };
  const validateYear = (year) => {
    const currentYear = new Date().getFullYear();
    return /^\d{4}$/.test(year) && year >= 1000 && year <= currentYear;
  };

  const formatPhoneNumber = (input) => {
    const digits = input.replace(/\D/g, "").replace(/^1/, "").slice(0, 10); // remove non-digits and trim to 10

    const parts = [];
    if (digits.length > 0) parts.push("(" + digits.slice(0, 3));
    if (digits.length >= 3) parts.push(") " + digits.slice(3, 6));
    if (digits.length >= 6) parts.push("-" + digits.slice(6, 10));

    return "+1 " + parts.join("");
  };

  const validatePhoneNumber = (val) => {
    if (val && typeof val === "string") {
      const regex = /^\+1\s\(\d{3}\)\s\d{3}-\d{4}$/;

      // Check format first
      if (!regex.test(val)) {
        setPhoneNumError("Please enter a valid phone number");
        setEmptyFields((prev) => ({
          ...prev,
          phone: true,
        }));
        return false;
      }

      // Remove all non-digit characters
      const digitsOnly = val.replace(/\D/g, "");

      // Check if all digits (after +1) are zeros
      if (/^0+$/.test(digitsOnly.slice(1))) {
        setPhoneNumError("Please enter a valid phone number");
        setEmptyFields((prev) => ({
          ...prev,
          phone: true,
        }));
        return false;
      }

      // If valid, clear any previous errors
      setPhoneNumError("");
      setEmptyFields((prev) => ({
        ...prev,
        phone: false,
      }));

      return true;
    }

    // Handle empty or invalid type
    setPhoneNumError("Phone number is required.");
    setEmptyFields((prev) => ({
      ...prev,
      phone: true,
    }));

    return false;
  };

  const validateZipCode = (value) => {
    const zip = value.trim();

    if (zip.length !== 5) {
      setZipError("Please enter a valid Zip code");
      setEmptyFields((prev) => ({
        ...prev,
        zip: true,
      }));
      return false;
    }

    // Check if all characters are zeros (any length)
    if (/^0{5}$/.test(zip)) {
      setZipError("Please enter a valid Zip code");
      setEmptyFields((prev) => ({
        ...prev,
        zip: true,
      }));
      return false;
    }

    return true;
  };

  const validatePassword = (password) => {
    if (!password) return false; // empty = not valid
    // accepts any non-alphanumeric as special character
    const strongPasswordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    return strongPasswordRegex.test(password);
  };

  console.log(emptyFields,"{}{}");
  
  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    // --- FILE UPLOAD HANDLING ONLY FOR FILE INPUTS ---
    if (type === "file") {
      e.preventDefault();
      const input = e.target; // get input reference
      const files = input.files;

      if (!files || files.length === 0) {
        setErrors((prev) => ({ ...prev, [name]: "" }));
        setEmptyFields((prev) => ({ ...prev, [name]: false }));
        setFormData((prev) => ({
          ...prev,
          [name]: name === "photoID" ? null : [],
        }));
        input.value = ""; // reset input value so same file can trigger again
        return;
      }

      const maxSize = maxSizes[name];
      const allowed = allowedTypes[name];
      const fileArray = Array.from(files);

      const existingFiles = Array.isArray(formData[name])
        ? formData[name]
        : formData[name]
        ? [formData[name]]
        : [];

      // ✅ Restrict total number of files to 10
      const totalFilesCount = existingFiles.length + fileArray.length;
      if (totalFilesCount > 10) {
        toast.warning("You cannot upload more than 10 files.");
        input.value = ""; // reset input
        return;
      }

      // ✅ Check for duplicate file names
      const duplicateFile = fileArray.find((newFile) =>
        existingFiles.some((existing) => existing.name === newFile.name)
      );

      if (duplicateFile) {
        toast.warning(`File "${duplicateFile.name}" already uploaded.`);
        input.value = ""; // reset input so same-file selection triggers again
        return;
      }

      // ✅ Validate file type and size
      const invalidFiles = fileArray.filter(
        (file) => !allowed.includes(file.type) || file.size > maxSize
      );

      if (invalidFiles.length > 0) {
        const invalid = invalidFiles[0];
        if (!allowed.includes(invalid.type)) {
          setErrors((prev) => ({
            ...prev,
            [name]: `Invalid file type. Allowed: ${allowed
              .map((t) => t.split("/")[1]?.toUpperCase() || t)
              .join(", ")}.`,
          }));
        } else if (invalid.size > maxSize) {
          const mb = maxSize / (1024 * 1024);
          setErrors((prev) => ({
            ...prev,
            [name]: `File "${invalid.name}" exceeds ${mb}MB limit.`,
          }));
        }
        setEmptyFields((prev) => ({ ...prev, [name]: true }));
        input.value = ""; // reset input again
        return;
      }

      // ✅ Clear errors and set files
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setEmptyFields((prev) => ({ ...prev, [name]: false }));
      setFormData((prev) => ({
        ...prev,
        [name]:
          name === "photoID"
            ? fileArray[0]
            : [...(prev[name] || []), ...fileArray],
      }));

      input.value = ""; // ✅ Always reset at the end
      return;
    }

    // --- NON-FILE INPUT HANDLING BELOW ---
    if (name === "email") setEmailErrors("");
    if (name === "routingNumber") setRoutingNumError("");
    if (name === "accountNumber") setAccountNumError("");
    if (name === "zip") setZipError("");
    if (name === "phone") setPhoneNumError("");

    setFormData((prev) => {
      const trimmedValue = [
        "password",
        "confirmPassword",
        "phone",
        "zip",
      ].includes(name)
        ? value
        : typeof value === "string"
        ? value.trimStart()
        : value;

      const updated = { ...prev, [name]: trimmedValue };

      // Auto-generate username
      if (name === "firstName" || name === "lastName") {
        updated.username = `${updated.firstName} ${updated.lastName}`.trim();
      }

      // Phone formatting
      if (name === "phone") {
        const formatted = formatPhoneNumber(value);
        updated.phone = formatted;
      }

      // Year validation
      if (name === "yearFounded") {
        const isValidYear = validateYear(value);
        setEmptyFields((prev) => ({ ...prev, yearFounded: !isValidYear }));
      }

      // ZIP validation
      if (name === "zip") {
        let digitsOnly = value.replace(/\D/g, "");
        if (digitsOnly.length > 5) digitsOnly = digitsOnly.slice(0, 5);
        updated.zip = digitsOnly;

        const isValidZip = digitsOnly.length === 5;
        setEmptyFields((prev) => ({ ...prev, zip: !isValidZip }));
      }

      // Date validation
      if (name === "dayOfBirth") {
        const isValidDate = validateDate(value);
        setEmptyFields((prev) => ({ ...prev, dayOfBirth: !isValidDate }));
      }

      // Password handling
      if (name === "password" || name === "confirmPassword") {
        const password = updated.password;
        const confirmPassword = updated.confirmPassword;

        const passwordValid = validatePassword(password);
        const passwordsMatch = password === confirmPassword;

        const passwordEmpty = !password;
        const confirmEmpty = !confirmPassword;

        setPasswordError("");

        if (passwordEmpty && confirmEmpty) {
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: false,
          }));
        } else if (!passwordValid && !passwordEmpty) {
          setPasswordError(
            "Password must be at least 8 characters long and contain at least one letter, one number, and one special character."
          );
          setEmptyFields((prev) => ({
            ...prev,
            password: true,
            confirmPassword: false,
          }));
        } else if (passwordValid && confirmPassword && !passwordsMatch) {
          setPasswordError("Passwords do not match.");
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: true,
          }));
        } else {
          setPasswordError("");
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: false,
          }));
        }
      } else {
        setEmptyFields((prev) => ({ ...prev, [name]: false }));
      }

      return updated;
    });
  };

  const clearSingleFile = (name, index) => {
    setFormData((prev) => {
      const updatedFiles = prev[name].filter((_, i) => i !== index);
      return {
        ...prev,
        [name]: updatedFiles.length > 0 ? updatedFiles : null, // ✅ set to null when empty
      };
    });

    // Optional: clear error if applicable
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // ✅ Reset input value (if all cleared)
    const input = document.getElementById(name);
    if (input) input.value = "";
  };

  const validateFilesExist = async (files = []) => {
    if (!files || files.length === 0)
      return { isValid: true, invalidFiles: [] };

    const invalidFiles = [];

    for (const fileObj of files) {
      const file = fileObj?.originalFile || fileObj?.file || fileObj;
      const fileName = fileObj?.name || "Unknown file";

      try {
        if (!(file instanceof File)) {
          invalidFiles.push(fileName);
          continue;
        }

        if (typeof file.arrayBuffer === "function") {
          await file.arrayBuffer();
        } else {
          await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve();
            reader.onerror = () => reject(new Error("Unable to read file."));
            reader.readAsArrayBuffer(file);
          });
        }
      } catch (err) {
        console.error(`Error reading file: ${fileName}`, err);
        invalidFiles.push(fileName);
      }
    }

    return {
      isValid: invalidFiles.length === 0,
      invalidFiles,
    };
  };

  const handleSubmit = async (e) => {
    console.log(state, "------------");

    e.preventDefault();

    // Validation logic
    if (state.userType === "Contractor" && !validateStep()) return;
    if (state.userType === "Project Owner" && !validateOwnerStep()) return;

    const passwordValid = validatePassword(formData.password);
    const passwordsMatch =
      formData.password === formData.confirmPassword &&
      !!formData.confirmPassword;

    const passwordEmpty = !formData.password;
    const confirmEmpty = !formData.confirmPassword;

    if (passwordEmpty || confirmEmpty || !passwordsMatch) {
      setPasswordError(true);
      setEmptyFields((prev) => ({
        ...prev,
        password: passwordEmpty || !passwordValid,
        confirmPassword: confirmEmpty || !passwordsMatch,
      }));

      if (passwordEmpty || confirmEmpty)
        toast.error("Password fields cannot be empty!");
      else if (!passwordsMatch) toast.error("Passwords do not match!");
      else
        toast.error(
          "Password must be at least 8 characters long, contain a letter, a number, and a special character."
        );
      return;
    }

const validations = [
  validateEmail(formData.email),
  validatePhoneNumber(formData.phone),
  validateZipCode(formData.zip),
  validateRoutingNumber(formData.routingNumber),
  validateAccountNumber(formData.accountNumber),
];

if (validations.includes(false)) return;


    // ✅ Validate uploaded files
    let allFilesValid = true;
    let invalidFileNames = [];

    const fileGroups = [];

    if (state.userType === "Contractor") {
      // fileGroups.push(formData.contractorLicense);
      fileGroups.push(formData.photoID);
      if (formData.AdditionalDocuments?.length)
        fileGroups.push(...formData.AdditionalDocuments);
    } else if (state.userType === "Project Owner") {
      if (formData.CopyOfID?.length) fileGroups.push(...formData.CopyOfID);
      if (formData.AdditionalDocuments?.length)
        fileGroups.push(...formData.AdditionalDocuments);
    }

    const { isValid, invalidFiles } = await validateFilesExist(fileGroups);

    if (!isValid) {
      allFilesValid = false;
      setInvalidFiles(invalidFiles); // 🟥 store invalid file names

      setEmptyFields((prev) => ({
        ...prev,
        fileError: true,
      }));

      const fileList = invalidFiles.join(", ");
      toast.warning(
        `Some files could not be read or are missing: ${fileList}. Please re-upload them.`
      );

      console.warn("Invalid files:", invalidFiles);
      return;
    } else {
      setInvalidFiles([]); // clear previous errors if everything’s valid
    }

    // ✅ If all validations pass, build FormData
    const formPayload = new FormData();
    formPayload.append(
      "role",
      state.userType.toLowerCase() === "contractor" ? "contractor" : "owner"
    );
    formPayload.append("email", formData.email);
    formPayload.append("user_name", formData.username);
    // formPayload.append("first_name", formData.firstName);
    // formPayload.append("last_name", formData.lastName);
    formPayload.append("phone", formData.phone);
    formPayload.append("address", formData.address);
    formPayload.append("city", formData.city);
    formPayload.append("state", formData.stateName);
    formPayload.append("zip", formData.zip);
    formPayload.append("password", formData.password);

    if (state.userType === "Contractor") {
      formPayload.append("company_name", formData.companyName || "");
      formPayload.append("cmp_found_year", formData.yearFounded || "");
      formPayload.append("no_of_employes", formData.employees || "");
      formPayload.append("accountname", formData.accountHolder || "");
      formPayload.append("bankname", formData.bankName || "");
      formPayload.append("routing_number", formData.routingNumber || "");
      formPayload.append("acnum", formData.accountNumber || "");

      if (formData.contractorLicense)
        formPayload.append("certificates", formData.contractorLicense);
      if (formData.photoID) formPayload.append("photo_id", formData.photoID);
      if (
        formData.AdditionalDocuments &&
        formData.AdditionalDocuments.length > 0
      ) {
        formData.AdditionalDocuments.forEach((file) => {
          formPayload.append("additional_documents", file);
        });
      }

      // if (formData.formationDoc)
      //   formPayload.append("formation_document", formData.formationDoc);
      // if (formData.IRSForm) formPayload.append("irs_form", formData.IRSForm);
      // if (formData.EINLetter)
      //   formPayload.append("ein_confirmation_letter", formData.EINLetter);
    } else if (state.userType === "Project Owner") {
      formPayload.append("co_owner", formData.coOwnerName || "");
      formPayload.append("accountname", formData.accountHolder || "");
      formPayload.append("bankname", formData.bankName || "");
      formPayload.append("routing_number", formData.routingNumber || "");
      formPayload.append("acnum", formData.accountNumber || "");
      console.log(formData?.CopyOfID);

      if (formData.CopyOfID)
        formPayload.append("photo_id", formData.CopyOfID?.[0]);

      formData.AdditionalDocuments.forEach((file) => {
        formPayload.append("additional_documents", file);
      });
      // if (formData.KYCBeneficial)
      //   formPayload.append("kyc_ownership_certificate", formData.KYCBeneficial);
      // if (formData.IRSForm) formPayload.append("irs_form", formData.IRSForm);
      // if (formData.EINLetter)
      //   formPayload.append("ein_confirmation_letter", formData.EINLetter);
    }

    // ✅ Submit if all checks pass
    try {
      setissubmitting(true);
      await axios.post("/cvault/create-user/", formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": undefined,
        },
        withCredentials: false,
      });

      toast.success("Registration successful!");
      setTimeout(() => navigate("/login"), 1500);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.error || "Registration failed");
    } finally {
      setissubmitting(false);
    }
  };

  const borderStyle = (field) =>
    emptyFields[field] ? { border: "1px solid red" } : { borderRadius: "6px" };

  // Validation for each step
  const validateStep = () => {
    let required = [];

    if (step === 1) {
      required = [
        "firstName",
        "lastName",
        "email",
        "phone",
        "address",
        "city",
        "stateName",
        "zip",
        "password",
        "confirmPassword",
        "companyName",
        "yearFounded",
        "employees",
        "contractorLicense",
        "accountHolder",
        "bankName",
        "routingNumber",
        "accountNumber",
        // "formationDoc",
        "photoID",
        // "EINLetter",
        // "IRSForm",
        "AdditionalDocuments",
      ];
    }

    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    if (step === 2 && formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      return false;
    }

    return true;
  };

  const validateOwnerStep = () => {
    let required = [];

    required = [
      "firstName",
      "lastName",
      "email",
      "phone",
      "address",
      "city",
      "stateName",
      "zip",
      "password",
      "confirmPassword",
      "accountHolder",
      "bankName",
      "routingNumber",
      "accountNumber",
      // "KYCBeneficial",
      "CopyOfID",
      // "IRSForm",
      "coOwnerName",
      "AdditionalDocuments",
    ];

    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    return true;
  };

  const validateRoutingNumber = (value) => {
    const routingNumber = value.trim();

    // Check length
    if (routingNumber.length !== 9) {
      setRoutingNumError("Please enter a valid Routing number");
      setEmptyFields((prev) => ({
        ...prev,
        routingNumber: true,
      }));
      return false;
    }

    // Check if all digits are 0
    if (/^0{9}$/.test(routingNumber)) {
      setRoutingNumError("Please enter a valid Routing number");
      setEmptyFields((prev) => ({
        ...prev,
        routingNumber: true,
      }));
      return false;
    }

    return true;
  };
  const validateAccountNumber = (value) => {
    const accountNumber = value.trim();

    // Check if all characters are zeros (any length)
    if (/^0+$/.test(accountNumber)) {
      setAccountNumError("Please enter a valid account number");
      setEmptyFields((prev) => ({
        ...prev,
        accountNumber: true,
      }));
      return false;
    }

    return true;
  };

  const handleNext = () => {
    // First: run your step-specific validation
    if (!validateStep()) return;

    // Check for password match
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");

      // Highlight password fields
      setEmptyFields((prev) => ({
        ...prev,
        password: true,
        confirmPassword: true,
      }));

      return; // Stop moving to next step
    }

    // Clear errors if all good
    setEmptyFields((prev) => ({
      ...prev,
      password: false,
      confirmPassword: false,
    }));

    // Move to the next step
    setStep((prev) => prev + 1);
  };

  const handleBack = () => setStep((prev) => prev - 1);
  const uploadContractorFields = [
    // {
    //   name: "formationDoc",
    //   label: "Formation Document",
    //   tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
    //   accept: ".pdf, image/png, image/jpeg",
    //   maxSize: 20 * 1024 * 1024, // 20MB
    // },
    {
      name: "photoID",
      label: "Photo ID",
      tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
      accept: ".pdf, image/png, image/jpeg",
      maxSize: 20 * 1024 * 1024, // 20MB
    },
    // {
    //   name: "EINLetter",
    //   label: "EIN Confirmation Letter",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    // {
    //   name: "IRSForm",
    //   label: "IRS Form W-9",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "AdditionalDocuments",
      label: "Additional Documents",
      tooltip:
        "You can upload up to 10 files. Each file must be a PDF or Excel document and not exceed 10 MB.",
      accept: ".pdf, .xls, .xlsx",
      maxSize: 10 * 1024 * 1024, // 10MB
    },
  ];

  const uploadOwnerFields = [
    // {
    //   name: "KYCBeneficial",
    //   label: "KYC Beneficial Ownership Certificate",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "CopyOfID",
      label: "Photo ID",
      tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
      accept: ".pdf, image/png, image/jpeg",
      maxSize: 20 * 1024 * 1024, // 20MB
    },
    // {
    //   name: "EINLetter",
    //   label: "EIN Confirmation Letter",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    // {
    //   name: "IRSForm",
    //   label: "IRS Form W-9",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "AdditionalDocuments",
      label: "Additional Documents",
      tooltip:
        "You can upload up to 10 files. Each file must be a PDF or Excel document and not exceed 10 MB.",
      accept: ".pdf, .xls, .xlsx",
      maxSize: 10 * 1024 * 1024, // 10MB
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6fb",
        // px: 2,
      }}
    >
      <Card
        elevation={0}
        sx={{
          width: 900,
          // maxHeight: "95vh",
          // p: 3,
          display: "flex",
          flexDirection: "column",
          borderRadius: 3,
          // boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
          backgroundColor: "#fff",
          my: 2,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 3 }}>
          <img src={Logo} alt="Logo" style={{ width: "90px" }} />
        </Box>

        <Typography
          variant="h5"
          align="center"
          sx={{
            fontWeight: 500,
            mb: 2,
            fontSize: 14,
            color: "#616161ff",
            mx: 2,
          }}
        >
          Complete the form below to create account for{" "}
          <span style={{ fontWeight: 600 }}>
            {state.userType === "Project Owner"
              ? "Owner/Project Owner"
              : state.userType}{" "}
          </span>
          . If you have any questions, feel free to contact our support team.
        </Typography>

        {/* {state.userType === "Contractor" && (
          <Stepper
            activeStep={step - 1}
            alternativeLabel
            sx={{
              mb: 2,
              "& .MuiStepLabel-label": { fontSize: 14 },
              "& .MuiStepIcon-root.Mui-active": { color: "#646464" },
              "& .MuiStepIcon-root.Mui-completed": { color: "#646464" },
            }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel> {label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        )} */}

        <Divider sx={{ mb: 0, color: "#eaeaea" }} />
        <Box sx={{ flex: 1, overflowY: "auto", p: 0 }}>
          {/* OWNER DIRECT FORM */}
          {state.userType === "Project Owner" && (
            <form
              onSubmit={handleSubmit}
              id="owner-form"
              style={{
                overflowX: "hidden",
              }}
            >
              <div
                style={{
                  backgroundColor: "#f3f3f3", // light background
                  borderBottom: "1px solid #d3d3d3",
                  padding: "14px",
                  // borderRadius: "4px",
                }}
              >
                <h5
                  style={{
                    fontWeight: 600,
                    color: "#646464",
                    fontSize: "16px",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Personal Information
                </h5>
              </div>
              <div className="row p-3">
                <div className="col-md-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    First Name <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    name="firstName"
                    placeholder="Enter First Name"
                    maxLength={60}
                    ref={firstNameRef}
                    className="form-control"
                    value={formData.firstName}
                    onKeyDown={(e) => {
                      // Block invalid keys before they appear
                      if (
                        !/^[a-zA-Z\s]$/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onChange={handleChange}
                    style={borderStyle("firstName")}
                  />
                </div>
                <div className="col-md-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Last Name <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    name="lastName"
                    className="form-control"
                    placeholder="Enter Last Name"
                    maxLength={40}
                    onKeyDown={(e) => {
                      // Block invalid keys before they appear
                      if (
                        !/^[a-zA-Z\s]$/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.lastName}
                    onChange={handleChange}
                    style={borderStyle("lastName")}
                  />
                </div>
                <div className="col-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    type="email"
                    placeholder="Enter Email"
                    maxLength={255}
                    name="email"
                    onBlur={handleBlur}
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                    style={borderStyle("email")}
                  />
                </div>
                <div className="col-md-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Phone <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    type="text"
                    // min={0}
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    name="phone"
                    placeholder="Enter Phone Number"
                    className="form-control"
                    value={formData.phone}
                    onBlur={(e) => validatePhoneNumber(e.target.value)}
                    onChange={handleChange}
                    style={borderStyle("phone")}
                  />
                </div>
                {emailErrors && (
                  <div
                    className={
                      emailErrors && phoneNumError
                        ? `col-6 mt-2`
                        : `col-12 mt-2`
                    }
                  >
                    <span style={{ fontSize: "14px" }} className="text-danger">
                      {emailErrors}
                    </span>
                  </div>
                )}
                {phoneNumError && (
                  <div
                    className={
                      emailErrors && phoneNumError
                        ? `col-6 mt-2`
                        : `col-12 mt-2`
                    }
                  >
                    <span style={{ fontSize: "14px" }} className="text-danger">
                      {phoneNumError}
                    </span>
                  </div>
                )}
                {/* Passwords */}
                <div className="col-md-6 mt-3">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Password <span className="text-danger">*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      readOnly={issubmitting}
                      type={showPassword ? "text" : "password"}
                      // onBlur={(e)=> validatePassword(e.target.value)}
                      name="password"
                      className="form-control"
                      placeholder="Enter Password"
                      maxLength={250}
                      value={formData.password}
                      onChange={handleChange}
                      style={borderStyle("password")}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: 10,
                        top: 5,
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      readOnly={issubmitting}
                      type={showConfirmPassword ? "text" : "password"}
                      // onBlur={(e)=> validatePassword(e.target.value)}
                      name="confirmPassword"
                      className="form-control"
                      placeholder="Enter Confirm Password"
                      maxLength={250}
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      style={borderStyle("confirmPassword")}
                    />
                    <span
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{
                        position: "absolute",
                        right: 10,
                        top: 5,
                        cursor: "pointer",
                      }}
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
                {passwordError && (
                  <div className="col-12 mt-2">
                    <span style={{ fontSize: "14px" }} className="text-danger">
                      {passwordError}
                    </span>
                  </div>
                )}

                <div className="col-md-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Co-Owner Name <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    type="text"
                    name="coOwnerName"
                    placeholder="Enter Co-Owner Name"
                    maxLength={500}
                    className="form-control"
                    onKeyDown={(e) => {
                      // Block invalid keys before they appear
                      if (
                        !/^[a-zA-Z\s]$/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.coOwnerName}
                    onChange={handleChange}
                    style={borderStyle("coOwnerName")}
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    type="text"
                    name="address"
                    rows={3}
                    readOnly={issubmitting}
                    className="form-control"
                    placeholder="Enter Address"
                    maxLength={100}
                    value={formData.address}
                    onChange={handleChange}
                    style={borderStyle("address")}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    City <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    type="text"
                    name="city"
                    onKeyDown={(e) => {
                      // Block invalid keys before they appear
                      if (
                        !/^[a-zA-Z\s]$/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className="form-control"
                    placeholder="Enter City"
                    maxLength={100}
                    value={formData.city}
                    onChange={handleChange}
                    style={borderStyle("city")}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    State <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    type="text"
                    name="stateName"
                    placeholder="Enter State"
                    maxLength={100}
                    className="form-control"
                    onKeyDown={(e) => {
                      // Block invalid keys before they appear
                      if (
                        !/^[a-zA-Z\s]$/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.stateName}
                    onChange={handleChange}
                    style={borderStyle("stateName")}
                  />
                </div>
                {console.log(formData, ":::::::::::::::::")}
                <div className="col-md-4 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Zip <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    type="number"
                    name="zip"
                    min={0}
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+" ||
                        e.key === "."
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className="form-control"
                    placeholder="Enter Zip"
                    onBlur={(e) => validateZipCode(e.target.value)}
                    value={formData.zip}
                    onChange={handleChange}
                    style={borderStyle("zip")}
                  />
                </div>
                {zipError && (
                  <div className={`col-12 mt-2`}>
                    <span style={{ fontSize: "14px" }} className="text-danger">
                      {zipError}
                    </span>
                  </div>
                )}
                {uploadOwnerFields.map(({ name, label, tooltip, accept }) => (
                  <div className="col-12 col-md-6 mt-3" key={name}>
                    {/* Label + Tooltip */}
                    <div
                      className="d-flex align-items-center justify-content-start mb-1"
                      style={{ fontWeight: 500, fontSize: "14px" }}
                    >
                      <label className="mb-0">
                        {label}{" "}
                        {label !== "EIN Confirmation Letter" ? (
                          <span className="text-danger">*</span>
                        ) : (
                          <span></span>
                        )}
                      </label>
                      <Tooltip title={tooltip}>
                        <span>
                          <IoMdInformationCircleOutline
                            fontSize={"16px"}
                            className="ms-1"
                          />
                        </span>
                      </Tooltip>
                    </div>

                    {/* Hidden Input */}
                    <input
                      readOnly={issubmitting}
                      type="file"
                      id={name}
                      name={name}
                      key={name}
                      onChange={handleChange}
                      disabled={issubmitting}
                      accept={accept}
                      multiple={name !== "CopyOfID"}
                      style={{ display: "none" }}
                    />

                    {/* Conditional rendering for CopyOfID */}
                    {name === "CopyOfID" ? (
                      // --- Single File Layout (like photoID) ---
                      <>
                        {!formData[name] ? (
                          <label
                            htmlFor={name}
                            className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              transition: "all 0.2s ease-in-out",
                              border: emptyFields[name]
                                ? "1px solid red"
                                : "1px dashed #878787ff",
                              color: "878787ff",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.background = "#fff")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.background = "#fff")
                            }
                          >
                            <i className="fa-solid fa-arrow-up-from-bracket"></i>
                            Upload
                          </label>
                        ) : (
                                <Tooltip title="Click to view">

                          <div
                            className="d-flex align-items-center justify-content-between border rounded px-2 py-2 mt-2"
                            style={{
                              fontSize: "13px",
                              backgroundColor: invalidFiles.includes(
                                formData[name]?.[0]?.name
                              )
                                ? "#fff"
                                : "#fff",
                              border: invalidFiles.includes(
                                formData[name]?.[0]?.name
                              )
                                ? "1px solid red"
                                : "1px solid #ccc",
                              borderRadius: "20px",
                              cursor:'pointer'
                            }}
                           
                          >
                            <div
                              className="text-truncate"
                              style={{ maxWidth: "80%" }}
                               onClick={() => {
                              const file = formData[name]?.[0];
                              if (file) {
                                const url = URL.createObjectURL(file);
                                setSelectedPdfFile(url);
                                setPreviewModaTitle("Photo ID");
                                setPreviewModal(true);
                              }
                            }}
                            >
                              <TextSnippetIcon className="me-2"
                          style={{ fontSize: 26, color: "#F5AE41" }}
                              />{formData[name]?.[0]?.name}
                            </div>
                            <i
                              className="fa-solid fa-xmark ms-2"
                              style={{ cursor: "pointer", color: "grey" }}
                              onClick={() => clearFile(name)}
                            ></i>
                          </div>
                          </Tooltip>
                        )}
                      </>
                    ) : (
                      // --- Default Layout for multi-file fields ---
                      <>
                        <label
                          htmlFor={name}
                          className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                          style={{
                            fontWeight: 400,
                            fontSize: "14px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                            border: emptyFields[name]
                              ? "1px solid red"
                              : "1px dashed #878787ff",
                            color: "878787ff",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.background = "#fff")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.background = "#fff")
                          }
                        >
                          <i className="fa-solid fa-arrow-up-from-bracket"></i>
                          Upload
                        </label>

                        {Array.isArray(formData[name]) &&
                          formData[name].length > 0 && (
                            <div className="d-flex flex-wrap mt-2 gap-2">
                              {formData[name].map((file, index) => (
                                <Tooltip title="Click to view">
                                <div
                                  key={index}
                                  className="d-flex align-items-center border rounded px-2 py-1"
                                  style={{
                                    fontSize: "13px",
                                    backgroundColor: invalidFiles.includes(
                                      file.name
                                    )
                                      ? "#fff"
                                      : "#fff",
                                    border: invalidFiles.includes(file.name)
                                      ? "1px solid red"
                                      : "1px solid #ccc",
                                    borderRadius: "20px",
                                    cursor:'pointer'
                                  }}
                                 

                                >
                                  <span
                                    className="text-truncate"
                                    style={{ maxWidth: "120px" }}
                                     onClick={() => {
  const filename = file.name;
  if (!filename) return;

  const url = URL.createObjectURL(file);
  const fileType = file.type;

  // Handle PDFs
  if (fileType === "application/pdf") {
    setSelectedPdfFile(url);
    setPreviewModaTitle("Additional Documents");
    setPreviewModal(true);
  }
  // For other file types (Excel, Word, etc.)
  else {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}}
                                  >
                                      <TextSnippetIcon className="me-2" 
                          style={{ fontSize: 26, color: "#F5AE41" }}
                                      />{file.name}
                                  </span>
                                  <i
                                    className="fa-solid fa-xmark ms-2"
                                    style={{ cursor: "pointer", color: "grey" }}
                                    onClick={() => clearSingleFile(name, index)}
                                  ></i>
                                </div>
                                </Tooltip>
                              ))}
                            </div>
                          )}
                      </>
                    )}

                    {/* Error Text */}
                    {errors[name] && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        {errors[name]}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div
                style={{
                  backgroundColor: "#f3f3f3", // light background
                  borderBottom: "1px solid #d3d3d3",
                  padding: "14px",
                  // borderRadius: "4px",
                }}
                className="mt-2"
              >
                <h5
                  style={{
                    fontWeight: 600,
                    color: "#646464",
                    fontSize: "16px",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Bank Information
                </h5>
              </div>
              <div className="row p-3">
                <div className="col-md-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Account Holder <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    name="accountHolder"
                    className="form-control"
                    value={formData.accountHolder}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      // Block invalid keys before they appear
                      if (
                        !/^[a-zA-Z\s]$/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="Enter Account Holder"
                    maxLength={100}
                    style={borderStyle("accountHolder")}
                  />
                </div>
                <div className="col-md-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Bank Name <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    name="bankName"
                    className="form-control"
                    value={formData.bankName}
                    onChange={handleChange}
                    placeholder="Enter Bank Name "
                    maxLength={100}
                    style={borderStyle("bankName")}
                    onKeyDown={(e) => {
                      // Block invalid keys before they appear
                      if (
                        !/^[a-zA-Z\s]$/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <div className="col-md-6 mt-2">
                  <div
                    className="d-flex align-items-center justify-content-start"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    <label
                      className="mb-1"
                      style={{ fontWeight: 500, fontSize: "14px" }}
                    >
                      Wire Routing Number{" "}
                      <span className="text-muted">
                        (Wire transfers only, no ACH)
                      </span>{" "}
                      <span className="text-danger">*</span>
                    </label>
                    {/* <Tooltip title="Please enter the routing number used specifically for wire transfers (not for ACH).">
                   
                      <span>
                        <IoMdInformationCircleOutline
                          fontSize={"16px"}
                          className="ms-1 mb-1"
                        />
                      </span>
                    </Tooltip> */}
                  </div>
                  <input
                    readOnly={issubmitting}
                    name="routingNumber"
                    type="number"
                    className="form-control"
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+" ||
                        e.key === "."
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.routingNumber}
                    onBlur={(e) => validateRoutingNumber(e.target.value)}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 9) {
                        handleChange(e);
                      }
                    }}
                    min={0}
                    max={999999999}
                    placeholder="Enter Routing Number"
                    style={borderStyle("routingNumber")}
                  />
                </div>

                <div className="col-md-6 mt-2">
                  <label
                    className="mb-1"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                    Account Number <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly={issubmitting}
                    name="accountNumber"
                    className="form-control"
                    onBlur={(e) => validateAccountNumber(e.target.value)}
                    min={0}
                    max={99999999999999999}
                    placeholder="Enter  Account Number "
                    type="number"
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+" ||
                        e.key === "."
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.accountNumber}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow empty string for deletion
                      if (value === "" || value.length <= 17) {
                        handleChange(e);
                      }
                    }}
                    style={borderStyle("accountNumber")}
                  />
                </div>
                {routingNumError && (
                  <div
                    className={
                      accountNumError && routingNumError
                        ? `col-6 mt-2`
                        : `col-12 mt-2`
                    }
                  >
                    <span style={{ fontSize: "14px" }} className="text-danger">
                      {routingNumError}
                    </span>
                  </div>
                )}
                {accountNumError && (
                  <div
                    className={
                      accountNumError && routingNumError
                        ? `col-6 mt-2`
                        : `col-12 mt-2`
                    }
                  >
                    <span style={{ fontSize: "14px" }} className="text-danger">
                      {accountNumError}
                    </span>
                  </div>
                )}
              </div>

              {/* <Button
              variant="contained"
              fullWidth
              sx={{ mt: 3, backgroundColor: "#646464" }}
              type="submit"
            >
              Register
            </Button> */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  mt: 2,
                  p: 3,
                  pt: 2,
                  borderTop: "1px solid #e0e0e0",
                  background: "#fff",
                }}
              >
                {/* {state.userType === "Contractor" && step > 1 && (
            <Button
              variant="outlined"
              sx={{
                marginTop: "5px", // Reduced margin
                borderColor: "#646464",
                color: "#646464",
                textTransform: "none",
                "&:hover": {
                  borderColor: "#0D1B64", // Custom hover color
                },
              }}
              onClick={handleBack}
              className="w-100 me-2"
            >
              Back
            </Button>
          )}
          {state.userType === "Contractor" && step < 2 && (
            <Button
              variant="contained"
              onClick={handleNext}
              className="w-100"
              sx={{
                marginTop: "5px", // Reduced margin
                backgroundColor: "#646464",
                color: "#fff",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#0D1B64", // Custom hover color
                },
              }}
            >
              Next <GrLinkNext className="ms-2"/>
            </Button>
          )} */}
                {/* {(state.userType === "Owner" ||
            (state.userType === "Contractor" && step === 2)) && ( */}

                {/* Terms and Conditions Checkbox */}
                <FormControlLabel
                  className="d-flex"
                  control={
                    <Checkbox
                      color="primary"
                      checked={agreeToTerms}
                      disabled={issubmitting}
                      onChange={(e) => {
                        setAgreeToTerms(e.target.checked);
                        setTermsError(false); // clear any error when user interacts
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2" color="text.secondary">
                      I agree to the{" "}
                      <Link underline="none" color="primary">
                        Terms and Conditions
                      </Link>
                    </Typography>
                  }
                  sx={{ alignSelf: "flex-start", mb: 1 }}
                />

                {/* Register Button */}
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!agreeToTerms || issubmitting}
                  className="w-100"
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#1A237E",
                    color: "#fff",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#0D1B64",
                    },
                  }}
                  // form={
                  //   state.userType === "Contractor" ? "contractor-form" : "owner-form"
                  // }
                >
                  {issubmitting ? (
                    <>
                      <span className="me-2">Registering...</span>
                      <CircularProgress size={18} color="inherit" />
                    </>
                  ) : (
                    "Register"
                  )}
                </Button>

                {/* Already have an account? Login */}
                <Typography
                  variant="body2"
                  sx={{
                    mt: 2,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Already have an account?{" "}
                  <Link
                    href="/login"
                    underline="none"
                    color="primary"
                    className="ms-1"
                  >
                    Login
                  </Link>
                </Typography>
              </Box>
            </form>
          )}

          {/* CONTRACTOR MULTI-STEP FORM */}
          {state.userType === "Contractor" && (
            <form
              onSubmit={handleSubmit}
              id="contractor-form"
              style={{
                overflowX: "hidden",
              }}
            >
              {step === 1 && (
                <>
                  {/* <h6 className="mb-3">Personal Details</h6> */}
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Personal Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="firstName"
                        placeholder="Enter First Name"
                        maxLength={60}
                        className="form-control"
                        ref={firstNameRef}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.firstName}
                        onChange={handleChange}
                        style={borderStyle("firstName")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="lastName"
                        className="form-control"
                        value={formData.lastName}
                        placeholder="Enter Last Name"
                        maxLength={40}
                        onChange={handleChange}
                        style={borderStyle("lastName")}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="email"
                        type="email"
                        onBlur={handleBlur}
                        className="form-control"
                        placeholder="Enter Email"
                        maxLength={255}
                        value={formData.email}
                        onChange={handleChange}
                        style={borderStyle("email")}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="phone"
                        className="form-control"
                        type="text"
                        min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter Phone Number"
                        value={formData.phone}
                        onBlur={(e) => validatePhoneNumber(e.target.value)}
                        onChange={handleChange}
                        style={borderStyle("phone")}
                      />
                    </div>
                    {emailErrors && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {emailErrors}
                        </span>
                      </div>
                    )}
                    {phoneNumError && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {phoneNumError}
                        </span>
                      </div>
                    )}
                    {/* Password Fields */}
                    <div className="col-md-6 mt-3">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Password <span className="text-danger">*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          readOnly={issubmitting}
                          type={showPassword ? "text" : "password"}
                          // onBlur={(e)=> validatePassword(e.target.value)}
                          name="password"
                          className="form-control"
                          placeholder="Enter Password"
                          maxLength={250}
                          value={formData.password}
                          onChange={handleChange}
                          style={borderStyle("password")}
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: "absolute",
                            right: 10,
                            top: 5,
                            cursor: "pointer",
                          }}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          readOnly={issubmitting}
                          type={showConfirmPassword ? "text" : "password"}
                          // onBlur={(e)=> validatePassword(e.target.value)}
                          name="confirmPassword"
                          className="form-control"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          placeholder="Enter Confirm Password"
                          maxLength={250}
                          style={borderStyle("confirmPassword")}
                        />
                        <span
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          style={{
                            position: "absolute",
                            right: 10,
                            top: 5,
                            cursor: "pointer",
                          }}
                        >
                          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </div>
                    {passwordError && (
                      <div className="col-12 mt-2">
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {passwordError}
                        </span>
                      </div>
                    )}

                    <div className="col-md-12 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Address <span className="text-danger">*</span>
                      </label>
                      <textarea
                        name="address"
                        rows={3}
                        className="form-control"
                        readOnly={issubmitting}
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Enter Address"
                        maxLength={100}
                        style={borderStyle("address")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        City <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="city"
                        className="form-control"
                        value={formData.city}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter City"
                        maxLength={100}
                        onChange={handleChange}
                        style={borderStyle("city")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        State <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="stateName"
                        className="form-control"
                        value={formData.stateName}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter State"
                        maxLength={100}
                        style={borderStyle("stateName")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Zip <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="zip"
                        type="number"
                        min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="form-control"
                        value={formData.zip}
                        onChange={handleChange}
                        onBlur={(e) => validateZipCode(e.target.value)}
                        style={borderStyle("zip")}
                        placeholder="Enter Zip"
                      />
                    </div>
                    {zipError && (
                      <div className={`col-12 mt-2`}>
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {zipError}
                        </span>
                      </div>
                    )}
                    {uploadContractorFields.map(
                      ({ name, label, tooltip, accept }) => (
                        <>
                          {name === "photoID" && (
                            <div className="col-12 mt-3" key={name}>
                              <div
                                className="d-flex align-items-center justify-content-between mb-1"
                                style={{ fontWeight: 500, fontSize: "14px" }}
                              >
                                <label className="mb-0">
                                  {label} <span className="text-danger">*</span>
                                </label>
                                <Tooltip title={tooltip}>
                                  <span>
                                    <IoMdInformationCircleOutline
                                      fontSize={"16px"}
                                      className="ms-1 mb-1"
                                    />
                                  </span>
                                </Tooltip>
                              </div>

                              {/* Hidden Input */}
                              <input
                                readOnly={issubmitting}
                                type="file"
                                id={name}
                                name={name}
                                onChange={handleChange}
                                disabled={issubmitting}
                                accept={accept}
                                style={{ display: "none" }}
                              />

                              {/* Upload Button or File Display */}
                              {!formData[name] ? (
                                <label
                                  htmlFor={name}
                                  className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    borderRadius: "6px",
                                    height: "50px",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    border: emptyFields[name]
                                      ? "1px solid red"
                                      : "1px dashed #878787ff",
                                    color: "878787ff",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.background = "#fff")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.background = "#fff")
                                  }
                                >
                                  <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                  Upload
                                </label>
                              ) : (
                                <Tooltip title="Click to view">

                                <div
                                  className="d-flex align-items-center border rounded px-2 py-2 justify-content-between"
                                  style={{
                                    fontSize: "13px",
                                    backgroundColor: invalidFiles.includes(
                                      formData[name]?.name
                                    )
                                      ? "#fff" // 🟥 light red background if invalid
                                      : "#fff",
                                    border: invalidFiles.includes(
                                      formData[name]?.name
                                    )
                                      ? "1px solid red"
                                      : "1px solid #ccc",
                                    borderRadius: "20px",
                                    transition: "all 0.3s ease-in-out",
                                    cursor:'pointer'
                                  }}
                                
                                >
                                  <div
                                    className="text-truncate"
                                    style={{ maxWidth: "80%" }}
                                      onClick={() => {
                                    const file = formData[name];
                                    if (file) {
                                      const url = URL.createObjectURL(file);
                                      setSelectedPdfFile(url);
                                      setPreviewModaTitle("Photo ID");

                                      setPreviewModal(true);
                                    }
                                  }}
                                  >
                                     <TextSnippetIcon className="me-2"
                          style={{ fontSize: 26, color: "#F5AE41" }}
                                     /> {formData[name].name}
                                    {/* {invalidFiles.includes(
                                      formData[name]?.name
                                    ) && (
                                      <i
                                        className="fa-solid fa-triangle-exclamation ms-2"
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                        title="This file could not be read. Please re-upload."
                                      ></i>
                                    )} */}
                                  </div>
                                  <i
                                    className="fa-solid fa-xmark ms-2"
                                    style={{ cursor: "pointer", color: "grey" }}
                                    onClick={() => clearFile(name)}
                                  ></i>
                                </div>
                                </Tooltip>
                              )}

                              {/* Error Text */}
                              {errors[name] && (
                                <div
                                  className="text-danger mt-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors[name]}
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )
                    )}
                  </div>

                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                    className="mt-2"
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Business Information
                    </h5>
                  </div>

                  {/* <h6 className="mb-3"> Company Details</h6> */}
                  <div className="row p-3">
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Company Name <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="companyName"
                        className="form-control"
                        value={formData.companyName}
                        onChange={handleChange}
                        // onKeyDown={(e) => {
                        //   // Block invalid keys before they appear
                        //   if (
                        //     !/^[a-zA-Z\s]$/.test(e.key) &&
                        //     e.key !== "Backspace" &&
                        //     e.key !== "Tab" &&
                        //     e.key !== "ArrowLeft" &&
                        //     e.key !== "ArrowRight" &&
                        //     e.key !== "Delete"
                        //   ) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        style={borderStyle("companyName")}
                        placeholder="Enter Company Name"
                        maxLength={500}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Year Founded <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={yearOptions}
                        value={yearOptions.find(
                          (option) => option.value === formData.yearFounded
                        )} // Ensure selected year is reflected
                        onChange={(selected) =>
                          handleChange({
                            target: {
                              name: "yearFounded",
                              value: selected.value,
                            },
                          })
                        }
                        isDisabled={issubmitting}
                        readOnly={issubmitting}
                        className="w-100"
                        styles={{
                          control: (base) => ({
                            ...base,
                            ...borderStyle("yearFounded"),
                            minHeight: "34px",

                            marginTop: "2.5px",
                          }),
                          option: (base) => ({
                            ...base,
                            paddingTop: 4,
                            paddingBottom: 4,
                          }),
                        }}
                        placeholder="Select Founded Year"
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Number of Employees{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        type="number"
                        name="employees"
                        className="form-control"
                        min={1}
                        placeholder="Enter Number of Employees"
                        value={formData.employees}
                        onChange={(e) => {
                          const value = e.target.value;
        setEmptyFields((prev) => ({ ...prev, "employees": false }));

                          if (value.length > 10) {
                            // If user types more than 10 characters, ignore extra input
                            return;
                          }

                          if (value === "" || parseInt(value) < 1) {
                            setFormData((prev) => ({ ...prev, employees: "" }));
                          } else {
                            setFormData((prev) => ({
                              ...prev,
                              employees: parseInt(value),
                            }));
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "." ||
                            (e.key === "0" && e.target.value === "")
                          ) {
                            e.preventDefault();
                          }
                        }}
                        style={borderStyle("employees")}
                      />
                    </div>
                    <div className="col-12 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Contractor License Information{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="contractorLicense"
                        className="form-control"
                        placeholder="Enter Contractor License Information"
                        value={formData.contractorLicense}
                        onChange={handleChange}
                        style={borderStyle("contractorLicense")}
                      />
                    </div>
                    {uploadContractorFields.map(
                      ({ name, label, tooltip, accept }) => (
                        <>
                          {name !== "photoID" && (
                            <div className="col-12 mt-3" key={name}>
                              <div
                                className="d-flex align-items-center justify-content-start mb-1"
                                style={{ fontWeight: 500, fontSize: "14px" }}
                              >
                                <label className="mb-0">
                                  {label} <span className="text-danger">*</span>
                                </label>
                                <Tooltip title={tooltip}>
                                  <span>
                                    <IoMdInformationCircleOutline
                                      fontSize={"16px"}
                                      className="ms-1 mb-1"
                                    />
                                  </span>
                                </Tooltip>
                              </div>

                              {/* Hidden Input (Multiple File Support) */}
                              <input
                                readOnly={issubmitting}
                                type="file"
                                id={name}
                                name={name}
                                onChange={(e) => handleChange(e, name)}
                                disabled={issubmitting}
                                accept={accept}
                                multiple
                                style={{ display: "none" }}
                              />

                              {/* Upload Button */}
                              <label
                                htmlFor={name}
                                className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                style={{
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                  height: "50px",
                                  transition: "all 0.2s ease-in-out",
                                  border: emptyFields[name]
                                    ? "1px solid red"
                                    : "1px dashed #878787ff",
                                  color: "878787ff",
                                }}
                                onMouseOver={(e) =>
                                  (e.currentTarget.style.background = "#fff")
                                }
                                onMouseOut={(e) =>
                                  (e.currentTarget.style.background = "#fff")
                                }
                              >
                                <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                Upload
                              </label>

                              {/* Display Uploaded Files as Chips */}
                              {formData[name]?.length > 0 && (
                                <div className="d-flex flex-wrap mt-2 gap-2">
                                  {formData[name].map((file, index) => (
                                <Tooltip title="Click to view">

                                    <div
                                      key={index}
                                      className="d-flex align-items-center border rounded px-2 py-1"
                                      style={{
                                        fontSize: "13px",
                                        backgroundColor: invalidFiles.includes(
                                          file.name
                                        )
                                          ? "#fff" // light red background
                                          : "#fff",
                                        border: invalidFiles.includes(file.name)
                                          ? "1px solid red"
                                          : "1px solid #ccc",
                                        borderRadius: "20px",
                                        cursor:'pointer'
                                      }}
                                    
                                    >
                                      <span
                                        className="text-truncate"
                                        style={{ maxWidth: "120px" }}
                                        onClick={() => {
  const filename = file.name;
  if (!filename) return;

  const url = URL.createObjectURL(file);
  const fileType = file.type;

  // Handle PDFs
  if (fileType === "application/pdf") {
    setSelectedPdfFile(url);
    setPreviewModaTitle("Additional Documents");
    setPreviewModal(true);
  }
 
  // For other file types (Excel, Word, etc.)
  else {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}}

                                      >
                                         <TextSnippetIcon className="me-2" 
                          style={{ fontSize: 26, color: "#F5AE41" }}
                                         /> {file.name}
                                      </span>
                                      <i
                                        className="fa-solid fa-xmark ms-2"
                                        style={{
                                          cursor: "pointer",
                                          color: "grey",
                                        }}
                                        onClick={() =>
                                          clearSingleFile(name, index)
                                        }
                                      ></i>
                                    </div>
                                    </Tooltip>
                                  ))}
                                </div>
                              )}

                              {errors[name] && (
                                <div
                                  className="text-danger mt-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors[name]}
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )
                    )}
                  </div>
                  {/* <h6 className="mb-2 mt-3">Bank Details</h6> */}
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Bank Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Account Holder <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="accountHolder"
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="form-control"
                        value={formData.accountHolder}
                        onChange={handleChange}
                        placeholder="Enter Account Holder"
                        maxLength={100}
                        style={borderStyle("accountHolder")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Bank Name <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="bankName"
                        className="form-control"
                        value={formData.bankName}
                        onChange={handleChange}
                        placeholder="Enter Bank Name "
                        maxLength={100}
                        style={borderStyle("bankName")}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <div
                        className="d-flex align-items-center justify-content-start"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        <label
                          className="mb-1"
                          style={{ fontWeight: 500, fontSize: "14px" }}
                        >
                          Wire Routing Number{" "}
                          <span className="text-muted">
                            (Wire transfers only, no ACH)
                          </span>{" "}
                          <span className="text-danger">*</span>
                        </label>
                        {/* <Tooltip title="Please enter the routing number used specifically for wire transfers (not for ACH).">
                          
                          <span>
                            <IoMdInformationCircleOutline
                              fontSize={"16px"}
                              className="ms-1 mb-1"
                            />
                          </span>
                        </Tooltip> */}
                      </div>
                      <input
                        readOnly={issubmitting}
                        name="routingNumber"
                        type="number"
                        className="form-control"
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.routingNumber}
                        onBlur={(e) => validateRoutingNumber(e.target.value)}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 9) {
                            handleChange(e);
                          }
                        }}
                        min={0}
                        max={999999999}
                        placeholder="Enter Routing Number"
                        style={borderStyle("routingNumber")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Account Number <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly={issubmitting}
                        name="accountNumber"
                        className="form-control"
                        min={0}
                        max={99999999999999999}
                        placeholder="Enter  Account Number "
                        type="number"
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.accountNumber}
                        onBlur={(e) => validateAccountNumber(e.target.value)}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow empty string for deletion
                          if (value === "" || value.length <= 17) {
                            handleChange(e);
                          }
                        }}
                        style={borderStyle("accountNumber")}
                      />
                    </div>
                    {routingNumError && (
                      <div
                        className={
                          accountNumError && routingNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {routingNumError}
                        </span>
                      </div>
                    )}
                    {accountNumError && (
                      <div
                        className={
                          accountNumError && routingNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {accountNumError}
                        </span>
                      </div>
                    )}

                    {/* Documents for Contractor */}
                    {/* <div className="row"> */}

                    {/* </div> */}
                  </div>
                </>
              )}

              {/* Step navigation buttons */}
              {/* <Box
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: step > 1 ? "space-between" : "flex-end",
              }}
            >
              {step > 1 && (
                <Button variant="outlined" onClick={handleBack}>
                  Back
                </Button>
              )}
              {step < 2 && (
                <Button
                  variant="contained"
                  onClick={handleNext}
                  sx={{ backgroundColor: "#646464" }}
                >
                  Next
                </Button>
              )}

              {step === 2 && (
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ backgroundColor: "#646464" }}
                >
                  Register
                </Button>
              )}
            </Box> */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  mt: 2,
                  p: 3,
                  pt: 2,
                  borderTop: "1px solid #e0e0e0",
                  background: "#fff",
                }}
              >
                {/* {state.userType === "Contractor" && step > 1 && (
            <Button
              variant="outlined"
              sx={{
                marginTop: "5px", // Reduced margin
                borderColor: "#646464",
                color: "#646464",
                textTransform: "none",
                "&:hover": {
                  borderColor: "#0D1B64", // Custom hover color
                },
              }}
              onClick={handleBack}
              className="w-100 me-2"
            >
              Back
            </Button>
          )}
          {state.userType === "Contractor" && step < 2 && (
            <Button
              variant="contained"
              onClick={handleNext}
              className="w-100"
              sx={{
                marginTop: "5px", // Reduced margin
                backgroundColor: "#646464",
                color: "#fff",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#0D1B64", // Custom hover color
                },
              }}
            >
              Next <GrLinkNext className="ms-2"/>
            </Button>
          )} */}
                {/* {(state.userType === "Owner" ||
            (state.userType === "Contractor" && step === 2)) && ( */}

                {/* Terms and Conditions Checkbox */}
                <FormControlLabel
                  className="d-flex"
                  control={
                    <Checkbox
                      color="primary"
                      disabled={issubmitting}
                      checked={agreeToTerms}
                      onChange={(e) => {
                        setAgreeToTerms(e.target.checked);
                        setTermsError(false); // clear any error when user interacts
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2" color="text.secondary">
                      I agree to the{" "}
                      <Link underline="none" color="primary">
                        Terms and Conditions
                      </Link>
                    </Typography>
                  }
                  sx={{ alignSelf: "flex-start", mb: 1 }}
                />

                {/* Register Button */}
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!agreeToTerms || issubmitting}
                  className="w-100"
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#1A237E",
                    color: "#fff",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#0D1B64",
                    },
                  }}
                  // form={
                  //   state.userType === "Contractor" ? "contractor-form" : "owner-form"
                  // }
                >
                  {issubmitting ? (
                    <>
                      <span className="me-2">Registering...</span>
                      <CircularProgress size={18} color="inherit" />
                    </>
                  ) : (
                    "Register"
                  )}
                </Button>

                {/* Already have an account? Login */}
                <Typography
                  variant="body2"
                  sx={{
                    mt: 2,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Already have an account?{" "}
                  <Link
                    href="/login"
                    underline="none"
                    color="primary"
                    className="ms-1"
                  >
                    Login
                  </Link>
                </Typography>
              </Box>
            </form>
          )}
        </Box>
        {/* Sticky Buttons */}
      </Card>

      <Modal
        open={previewModal}
        onClose={() => {
          setPreviewModal(false);
          setPreviewModaTitle("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            // maxHeight: "100vh", // Ensure the modal does not exceed viewport height
            overflowY: "auto",
          }}
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <div>
                <h5>{previewModaTitle}</h5>
              </div>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setPreviewModal(false);
                  setPreviewModaTitle("");
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedPdfFile && (
                <iframe
                  title="PDF Viewer"
                  style={iframeStyleContractPdf}
                  src={selectedPdfFile}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </Box>
  );
}

export default RegisterForm;
